import React , { useEffect , useState } from "react";
import "./Praktika.css";

import { BodyHeader } from "../../cvComponents/BodyHeader/BodyHeader";
// myDiv
import { AusbildungsBody } from "../../../../Screens/lebenslauf/Lebenslauf";

// For Admin
import { ChangedData } from "../../../../assets/ChangedData/ChangedData";
import { allData } from "../../../../Screens/lebenslauf/Lebenslauf";

// Images
import myWork from "../../../../assets/imags/MyWork.svg";



export const Praktika = (props) =>{

    const data = props.data;
    const title = props.title;
    const allDataindex = props.index;
    
    /*_*/   const [ RendUi , seRendUi ] = useState("");

    useEffect(()=>{
        RendrUi();
    },[]);

    const RendrUi = () =>{
        const rend = data.map( (section , i) => 
            <div className="ItemofTime">
                <div className="circelItem">
                    <div className="circelItemIN"></div>
                </div>
                <span className="jahrdsAusbs" onClick={aa} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} id={`dateP_${i}`} > { section.Date } </span>
                <div className="bodyOfJTimAusb">
                    <p className="hggLabel" onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} id={`KeyPad${i}`} >{ section.value }</p>
                    <p className="hggLabel hggLabeldeck" onClick={toTextEditFunction} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} id={`vluyPA${i}`} >{ section.key }</p>
                </div>
            </div>
        );

        seRendUi(rend);

        setTimeout(() => {
            const ItemofTime = document.querySelectorAll(".PraktikaBody .ItemofTime");
            ItemofTime[0].classList.add("ItemofTimeActive");
    
            const bodyOfJTimAusb = document.querySelectorAll(".PraktikaBody .bodyOfJTimAusb");
            bodyOfJTimAusb[0].classList.add("bodyOfJTimAusbActive");
        }, 20);



    }







    const aa = (event) => {
        const ItemofTime = document.querySelectorAll(".ItemofTime");


        let i = event.target.nextSibling;
        
        let bodyOfJTimAusb = document.getElementsByClassName("bodyOfJTimAusb");
        let myIndex = 0;
        for (let index = 0; index < bodyOfJTimAusb.length; index++) {
            if (bodyOfJTimAusb[index] == i) {
                myIndex = index;
                console.log(index);
            }
        }
        bodyOfJTimAusb[myIndex].classList.toggle("bodyOfJTimAusbActive");
        AusbildungsBody[0].style.height = "max-content";


        ItemofTime[myIndex].classList.toggle("ItemofTimeActive");

        if (localStorage.getItem("isLogged") == "true") {
            toTextEditFunction(event);
        }
    }












    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }
    const toTextEditFunction = (event) => {
        
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 1) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = "CVsections";
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;
                    let index = atributname.match(/\d+/g);
                    let way = allData.sec[allDataindex].dat[index];

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        switch (atributname[0]) {
                            case "d":
                                way.Date = textafter;
                                break;
                            case "v":
                                way.value = textafter;
                                break;
                            case "k":
                                way.key = textafter;
                                break;
                            default:
                                break;
                        }

                        // allData.sec[index[0]].head.title = textafter;
                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }else{
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
        
    }




























    return(
        <div>
            <BodyHeader title={title} idd={allDataindex} />

            <div className="PraktikaBody">

                <div className="workImageContainer">
                    <img src={myWork} className="myWorkImage"/>
                </div>


                { RendUi }

                

                {/* 
                <div className="ItemofTime ItemofTimeActive">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>
  
                    <span className="jahrdsAusbs" onClick={aa} >8/2021 - Heute</span>

                    <div className="bodyOfJTimAusb bodyOfJTimAusbActive">
                        <p className="hggLabel">Telekom AG, Bonn</p>
                        <p className="hggLabel hggLabeldeck">Einstiegsqualifizierungsjahr als IT-Systemelektroniker</p>
                    </div>
                </div>



                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN">
                        </div>
                    </div>


                        <span className="jahrdsAusbs" onClick={aa}>5/2021 - 7/2021</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Frenken {"&"} co.</p>
                        <p className="hggLabel hggLabeldeck">Datenerfasser im Impfzentrum in Teilzeit</p>
                    </div>
                </div>



                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                        <span className="jahrdsAusbs" onClick={aa}>12/2020 – 5/2021</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Rewe Center, Rewe Markt GmbH, Bonn</p>
                        <p className="hggLabel hggLabeldeck">Regalservice in Teilzeit</p>
                    </div>
                </div>



                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                    <span className="jahrdsAusbs" onClick={aa}>7/2013 – 10/2013 - 7/2014 -10/2014</span>


                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Mobilfunkeinzelhandel Itisalat, Ariha</p>
                        <p className="hggLabel hggLabeldeck">Verkäufer in Teilzeit</p>
                    </div>
                </div>



                <div className="ItemofTime">
                    <div className="circelItem">
                        <div className="circelItemIN"></div>
                    </div>


                    <span className="jahrdsAusbs" onClick={aa}>7/2009 – 10/2009</span>
                    <div className="bodyOfJTimAusb">
                        <p className="hggLabel">Tischlerei Abomoaheb, Aleppo</p>
                        <p className="hggLabel hggLabeldeck">Praktikum als Tischler</p>
                    </div>
                </div>

                */}
                

            </div>
        </div>
    );
}